import React, { useCallback, useEffect, useReducer } from "react";
import { getUniqueV2, reducerFn } from "../../helper";
import { Autocomplete, Button, Tag } from "@shopify/polaris";
import styled from "styled-components";

const TYPE_OPTIONS = [
    { value: "mug", label: "Mug" },
    { value: "tumbler", label: "Tumbler" },
    { value: "blanket", label: "Blanket" },
    { value: "poster", label: "Poster" },
    { value: "ornament", label: "Ornament" },
    { value: "shirt", label: "Shirt" },
    { value: "towel", label: "Towel" },
];

export default function AmazonIdeaType({ index, onChange, value: valueProp }) {
    const [value, options] = formatValue(valueProp);
    const [state, setState] = useReducer(reducerFn, {
        input: "",
        options: TYPE_OPTIONS,
        selected: valueProp,
        deselectedOption: TYPE_OPTIONS,
        selectedOptions: [],
    });

    // useEffect(() => {
    //     const [value, options] = formatValue(valueProp);
    //     setState({
    //         options,
    //         selected: value,
    //         deselectedOption: options,
    //         selectedOptions: options,
    //     });
    // }, [valueProp]);

    const handleInputChange = useCallback(
        (input) => {
            setState({ input });

            if (!input) {
                setState((state) => ({
                    ...state,
                    options: state.deselectedOption,
                }));
                return;
            }

            try {
                const resultOptions = state.deselectedOption.filter(
                    (option) => option.label === input,
                );
                setState({ options: resultOptions });
            } catch (error) {
                console.error(error?.toString());
            }
        },
        [state.deselectedOption],
    );

    const handleSelection = useCallback(
        (selected) => {
            setState((p) => {
                // const selectedValues = (p.deselectedOption || []).filter(
                //     (opt) => selected.includes(opt.value),
                // );
                // return { ...p, selected, selectedOptions: selectedValues };
                const selectedValue = (p.deselectedOption || []).find((opt) =>
                    selected.includes(opt.value),
                );
                return {
                    ...p,
                    selected,
                    selectedOptions: [selectedValue],
                    input: selectedValue.label,
                };
            });

            onChange(selected);
        },
        [onChange],
    );

    const handleAddValue = useCallback(() => {
        const option = genOption(state.input);
        let selected = state.selected;
        setState((p) => {
            const deselectedOption = p.deselectedOption;
            const selectedOpts = new Map(
                [...deselectedOption, option].map((opt) => [opt.value, opt]),
                // [option].map((opt) => [opt.value, opt]),
            );

            // selected = Array.from(new Set([...p.selected, option.value]));
            selected = Array.from(new Set([option.value]));
            // const selectedOptions = getUniqueV2("value", p.selectedOptions, [
            // ]);
            const selectedOptions = [option];

            return {
                ...p,
                // input: "",
                input: option.label,
                selected,
                deselectedOption: Array.from(selectedOpts.values()),
                options: Array.from(selectedOpts.values()),
                selectedOptions: Array.from(selectedOptions.values()),
            };
        });

        onChange(selected);
    }, [state.input, state.selected]);

    const handleClearButton = useCallback(() => {
        setState((p) => ({ ...p, input: "", options: p.deselectedOption }));

        onChange([]);
    }, []);

    const handleRemove = useCallback(
        (value) => () => {
            const filterFn = (item) =>
                typeof item == "object" ? item.value !== value : item !== value;

            let selected = state.selected;
            setState((p) => {
                selected = state.selected.filter(filterFn);
                const selectedOptions = p.selectedOptions.filter(filterFn);

                return {
                    ...p,
                    selected,
                    selectedOptions,
                };
            });

            onChange && onChange(selected);
        },
        [state.selected],
    );

    const textField = (
        <Autocomplete.TextField
            id={`field_${index}`}
            label="Type"
            value={state.input}
            onChange={handleInputChange}
            clearButton
            onClearButtonClick={handleClearButton}
        />
    );

    return (
        <div>
            <Autocomplete
                options={state.options}
                selected={state.selected}
                onSelect={handleSelection}
                textField={textField}
                emptyState={
                    state.input ? (
                        <Button plain onClick={handleAddValue}>
                            <b>Add: </b> {state.input}
                        </Button>
                    ) : (
                        <span>No items found!</span>
                    )
                }
            />

            {/* {state.selectedOptions && state.selectedOptions.length > 0 ? (
                <TagContainer>
                    {state.selectedOptions.map((item) => (
                        <Tag
                            children={item.label}
                            onRemove={handleRemove(item.value)}
                            key={item.value}
                        />
                    ))}
                </TagContainer>
            ) : null} */}
        </div>
    );
}

function genOption(value) {
    return { value, label: value };
}

function formatValue(values) {
    const options = new Map();
    for (let val of values) {
        if (!val || !val.value || !val.label) {
            continue;
        }

        const { value } = val;
        options.set(value, val);
    }

    return [values, Array.from(options.values())];
}

const TagContainer = styled.div`
    display: flex;
    padding-top: 0.8rem;
    flex-wrap: wrap;
    > * {
        margin-right: 0.8rem;
        margin-bottom: 0.8rem;
    }
`;
